(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pinto-google-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pinto-review-carousel')) {
  customElements.define('pinto-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) this.cleanup();
      const track = this.querySelector('.pinto-reviews__quotes');
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      if (!track || !previous || !next) return;
      const controller = new AbortController();
      const update = () => {
        const end = track.scrollWidth - track.clientWidth;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end - 2;
        this.querySelector('.pinto-reviews__controls').hidden = end <= 2;
      };
      const move = (direction) => {
        const card = track.querySelector('.pinto-reviews__quote');
        if (!card) return;
        track.scrollBy({
          left: direction * (card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0)),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      previous.addEventListener('click', () => move(-1), {signal:controller.signal});
      next.addEventListener('click', () => move(1), {signal:controller.signal});
      track.addEventListener('scroll', update, {passive:true,signal:controller.signal});
      const observer = new ResizeObserver(update);
      observer.observe(track);
      this.cleanup = () => {controller.abort();observer.disconnect();};
      update();
    }
    disconnectedCallback() {if (this.cleanup) this.cleanup();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
